"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getTimeAgo, numberWithCommas } from "@/helpers/Helpers";
import WaveHeaderFollow, { WaveFollowBtnSize } from "./WaveHeaderFollow";
import { AuthContext } from "@/components/auth/Auth";
import WaveHeaderOptions from "./options/WaveHeaderOptions";
import WaveHeaderName from "./name/WaveHeaderName";
import WaveHeaderFollowers from "./WaveHeaderFollowers";
import WaveHeaderPinButton from "./WaveHeaderPinButton";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WavePicture from "../WavePicture";
import { Time } from "@/helpers/time";
import WaveNotificationSettings from "../specs/WaveNotificationSettings";
import { canEditWave } from "@/helpers/waves/waves.helpers";
import WaveHeaderPictureEdit from "./picture/WaveHeaderPictureEdit";
interface WaveHeaderProps {
  readonly wave: ApiWave;
  readonly onFollowersClick: () => void;
  readonly useRing?: boolean | undefined;
  readonly useRounded?: boolean | undefined;
}
export default function WaveHeader(t0) {
  const $ = _c(73);
  const {
    wave,
    onFollowersClick,
    useRing: t1,
    useRounded: t2
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const useRounded = t2 === undefined ? true : t2;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t3;
  if ($[0] !== wave.created_at) {
    t3 = getTimeAgo(wave.created_at);
    $[0] = wave.created_at;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const created = t3;
  let t4;
  if ($[2] !== wave.contributors_overview) {
    t4 = wave.contributors_overview.slice(0, 10);
    $[2] = wave.contributors_overview;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const firstXContributors = t4;
  const isDropWave = wave.wave.type !== ApiWaveType.Chat;
  const isDirectMessage = wave.chat.scope.group?.is_direct_message ?? false;
  let t5;
  if ($[4] !== activeProfileProxy || $[5] !== connectedProfile || $[6] !== isDirectMessage || $[7] !== wave) {
    t5 = !isDirectMessage && canEditWave({
      connectedProfile,
      activeProfileProxy,
      wave
    });
    $[4] = activeProfileProxy;
    $[5] = connectedProfile;
    $[6] = isDirectMessage;
    $[7] = wave;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const canEdit = t5;
  let ringClasses = "";
  if (useRing) {
    ringClasses = "tw-rounded-xl tw-ring-1 tw-ring-inset tw-ring-iron-800/60 tw-shadow-sm";
  } else {
    if (useRounded) {
      ringClasses = "tw-rounded-t-xl lg:tw-rounded-t-none";
    }
  }
  const connectedHandle = connectedProfile?.handle;
  const canUseWaveActions = !!connectedHandle && !activeProfileProxy;
  const showNotificationSettings = canUseWaveActions && !!wave.subscribed_actions.length;
  const showOwnerOptions = canUseWaveActions && connectedHandle === wave.author.handle;
  const t6 = `tw-relative tw-overflow-hidden tw-bg-iron-950 ${ringClasses}`;
  const t7 = `${useRounded ? "tw-rounded-t-xl tw-ring-1 tw-ring-inset tw-ring-iron-800/70" : ""} tw-overflow-hidden tw-bg-iron-950`;
  const t8 = `linear-gradient(135deg, ${wave.author.banner1_color ?? "#1f2937"} 0%, ${wave.author.banner2_color ?? "#0f172a"} 58%, #050505 100%)`;
  let t9;
  if ($[9] !== t8) {
    t9 = {
      background: t8,
      boxShadow: "inset 0 -22px 34px rgba(0,0,0,0.42)"
    };
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-px tw-bg-white/10" />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t9) {
    t11 = <div className="tw-relative tw-h-16 tw-w-full tw-object-cover" style={t9}>{t10}</div>;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[14] = t11;
    $[15] = t7;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `tw-absolute tw-inset-0 tw-overflow-hidden tw-rounded-full tw-bg-iron-900 tw-shadow-[0_18px_36px_rgba(0,0,0,0.35)] ${isDropWave ? "tw-ring-2 tw-ring-white/15" : ""}`;
  const t14 = wave.name;
  const t15 = wave.picture;
  let t16;
  if ($[17] !== wave.contributors_overview) {
    t16 = wave.contributors_overview.map(_temp);
    $[17] = wave.contributors_overview;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t16 || $[20] !== wave.name || $[21] !== wave.picture) {
    t17 = <WavePicture name={t14} picture={t15} contributors={t16} roundedClassName="tw-rounded-full" />;
    $[19] = t16;
    $[20] = wave.name;
    $[21] = wave.picture;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t13 || $[24] !== t17) {
    t18 = <div className={t13}>{t17}</div>;
    $[23] = t13;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== canEdit || $[27] !== wave) {
    t19 = canEdit && <div className="tw-absolute tw-inset-0"><WaveHeaderPictureEdit wave={wave} /></div>;
    $[26] = canEdit;
    $[27] = wave;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== isDropWave) {
    t20 = isDropWave && <div className="tw-absolute -tw-bottom-1 -tw-right-1 tw-flex tw-size-6 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-iron-800/70 tw-bg-iron-950 tw-shadow-md"><svg className="tw-size-3.5 tw-flex-shrink-0 tw-text-[#E8D48A]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z" /></svg></div>;
    $[29] = isDropWave;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t18 || $[32] !== t19 || $[33] !== t20) {
    t21 = <div className="tw-group tw-relative tw-h-16 tw-w-16 tw-shrink-0">{t18}{t19}{t20}</div>;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== canUseWaveActions || $[36] !== showNotificationSettings || $[37] !== showOwnerOptions || $[38] !== wave) {
    t22 = canUseWaveActions && <div className="tw-mt-8 tw-flex tw-min-w-0 tw-flex-1 tw-flex-nowrap tw-items-center tw-justify-end tw-gap-1.5">{showNotificationSettings && <div className="tw-shrink-0"><WaveNotificationSettings wave={wave} compact={true} /></div>}{showOwnerOptions && <div className="tw-flex tw-shrink-0 tw-items-center"><WaveHeaderOptions wave={wave} /></div>}<div className="tw-shrink-0"><WaveHeaderFollow wave={wave} size={WaveFollowBtnSize.SMALL} /></div></div>;
    $[35] = canUseWaveActions;
    $[36] = showNotificationSettings;
    $[37] = showOwnerOptions;
    $[38] = wave;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t21 || $[41] !== t22) {
    t23 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-x-4">{t21}{t22}</div>;
    $[40] = t21;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== wave) {
    t24 = <div className="tw-min-w-0 tw-flex-1"><WaveHeaderName wave={wave} /></div>;
    $[43] = wave;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== wave.id) {
    t25 = <div className="tw-flex tw-shrink-0 tw-items-center tw-justify-end"><WaveHeaderPinButton waveId={wave.id} /></div>;
    $[45] = wave.id;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t24 || $[48] !== t25) {
    t26 = <div className="tw-mt-5 tw-flex tw-min-w-0 tw-items-start tw-gap-x-3">{t24}{t25}</div>;
    $[47] = t24;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== wave.created_at) {
    t27 = Time.millis(wave.created_at).toDate().toLocaleDateString();
    $[50] = wave.created_at;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== created || $[53] !== t27) {
    t28 = <div className="tw-text-sm"><span className="tw-font-normal tw-text-iron-500">Created {created} ·{" "}{t27}</span></div>;
    $[52] = created;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== onFollowersClick || $[56] !== wave) {
    t29 = <WaveHeaderFollowers wave={wave} onFollowersClick={onFollowersClick} />;
    $[55] = onFollowersClick;
    $[56] = wave;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== firstXContributors.length || $[59] !== wave.metrics) {
    t30 = !!firstXContributors.length && <div className="tw-flex tw-items-center"><span className="tw-ml-2.5 tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-500"><span className="tw-text-sm tw-font-medium tw-leading-5 tw-text-iron-50">{numberWithCommas(wave.metrics.drops_count)}</span>{" "}{wave.metrics.drops_count === 1 ? "Post" : "Posts"}</span></div>;
    $[58] = firstXContributors.length;
    $[59] = wave.metrics;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t29 || $[62] !== t30) {
    t31 = <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-y-3"><div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4"><div className="tw-flex tw-items-center tw-gap-x-4">{t29}{t30}</div></div></div>;
    $[61] = t29;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== t23 || $[65] !== t26 || $[66] !== t28 || $[67] !== t31) {
    t32 = <div className="-tw-mt-6 tw-px-4 tw-pb-6">{t23}{t26}{t28}{t31}</div>;
    $[64] = t23;
    $[65] = t26;
    $[66] = t28;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== t12 || $[70] !== t32 || $[71] !== t6) {
    t33 = <div className={t6}>{t12}{t32}</div>;
    $[69] = t12;
    $[70] = t32;
    $[71] = t6;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  return t33;
}
function _temp(c) {
  return {
    pfp: c.contributor_pfp,
    identity: c.contributor_identity
  };
}